import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import Tablereact from '../common/tabulator/tablereact'
import Button from 'react-bootstrap-button-loader';
import { toast } from 'react-toastify'; 
import Loader from '../common/loaderapp';

const Subdepartamentos = () => {
    const [page, setPage] = useState(-1);
    const [look, setLook] = useState(false);
    const [datos, setDatos] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [nombre, setNombre] = useState('');
    const [idDep, setIdDep] = useState(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        fetch('/p_subdepartamento', { method: 'GET', headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => {setDatos(res); setLoad(true)})
        .catch(err => {console.log('Error: '+err);setLook(false)})

        fetch('/p_departamento', { method: 'GET', headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => setDepartamentos(res))
        .catch(err => {console.log('Error: '+err);})
    }, [look]);

    const cabecera = [
        { Header: <b>Id</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'100px', editable:true , show:false},
        { Header: <b>Nombre</b>, accessor: 'NOMBRE', style: { textAlign: 'center'}, width:'Auto', editable:true , show:true},
        { Header: <b>Departamento</b>, accessor: 'DEPARTAMENTO', style: { textAlign: 'center'}, width:'Auto', editable:false , show:true},
    ];

    const agregar=()=>{ setPage(0); setIdDep(null); }

    const actualizar=(dato)=>{
        setPage(dato.ID)
        setNombre(dato.NOMBRE)
        setIdDep(dato.ID_DEP || null)
    }

    const eliminar=(dato)=>{
        setLook(true);
        fetch('/p_subdepartamento', { method: 'DELETE', body: JSON.stringify({ID:dato.ID}), headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => {
            setDatos(Array.isArray(res) ? res : []);
            setLook(false);
        })
        .catch(err => {console.log('Error: '+err);setLook(false)})
    }

    const getSubdepartamentoDeleteWarning = (item = {}) => {
        const totalProductos = Number(item.TOTAL_PRODUCTOS ?? item.total_productos ?? 0);
        if (totalProductos <= 0) return null;
        return `Al desactivar este subdepartamento también se desactivarán ${totalProductos === 1 ? '1 producto' : `${totalProductos} productos`} relacionados.`;
    };

    const insetar_actualizar=()=>{
        if(nombre.trim().length==''){
            toast.warn(`Asigna un nombre.`,{ position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
        if(!idDep){
            toast.warn(`Selecciona un departamento.`,{ position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
        setLook(true)
        fetch('/p_subdepartamento', { method: page == 0 ? 'POST':'PUT', body: JSON.stringify({ID:page,nombre, ID_DEP:idDep}), headers: {'Content-Type': 'application/json'} })
        .then(async res => {
            const payload = await res.json().catch(() => ({}));
            if (!res.ok || payload?.status === 'ERROR') {
                const message = payload?.resultado || 'No se pudo guardar el subdepartamento.';
                toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT });
                setLook(false);
                return;
            }
            setLook(false);
            setPage(-1);
            setNombre('');
            setIdDep(null);
        })
        .catch(err => {console.log('Error: '+err);setLook(false)})
    }

    return (
        <div className="col-sm-12">
            <div className="card">
                {
                    load ==true?
                        (page == -1) ?
                        <Fragment>
                            <div className="card-body datatable-react">
                                <Tablereact
                                    myData={datos}
                                    cabecera={cabecera}
                                    pageSize={10}
                                    paginacion={true}
                                    buscador='Buscar'
                                    boton={{text:'Agregar Subdepartamento',function:agregar}}
                                    eliminar_actualizar={{actualizar:actualizar,eliminar:eliminar}}
                                    renderDeleteWarning={getSubdepartamentoDeleteWarning}
                                />
                            </div>
                        </Fragment>
                        :
                        <Fragment>
                            <div className="card-header" style={{padding:'15px'}}>
                                <button className="btn btn-outline-light-2x txt-dark" onClick={()=>{setPage(-1); setNombre('')}} disabled={look}>
                                    <i className="icofont icofont-arrow-left"/>Regresar
                                </button>
                            </div>
                            <h4 className="mt-3 ml-4"><strong>{page==0 ? 'Agregar Subdepartamento':'Actualizar Subdepartamento'}</strong></h4>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className={`form-label`}>Nombre del Subdepartamento</label>
                                            <input name={`nombre`} value={nombre} onChange={(e)=>setNombre(e.target.value)} className={`form-control`} type="text" autoComplete="off"/>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className={`form-label`}>Departamento</label>
                                            <select className={`form-control`} value={idDep ?? ''} onChange={(e)=>{ const v = e.target.value; setIdDep(v ? parseInt(v) : null); }}>
                                                <option value=''>Selecciona un departamento</option>
                                                {departamentos && departamentos.map(d => (
                                                    <option key={d.ID} value={d.ID}>{d.NOMBRE}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <div className="text-right">
                                        <Button className='btn-lg mr-4' onClick={insetar_actualizar} loading={look}>Guardar</Button>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    : <Loader/>
                }
            </div>
        </div>
    );
}
 
export default Subdepartamentos;
